import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
import axios from 'axios';
import { getSwimLaneHeader } from '@/common/swim-lane';
import { showLoading, hideLoading } from '@/utils/loading';
import Toast from '@/components/toast';
import { useK18n } from '@/common/k18n';
import { Jose } from '@ks-cqc/h5-sig4-lite';
import { logger, radarLog } from '@/common/log';
var service = axios.create({
  baseURL: '/',
  timeout: 30 * 1000,
  headers: _objectSpread({}, getSwimLaneHeader()),
  showLoading: true,
  silent: false,
  erroToast: true
});
// 2、签名方法调用：通过config注入签名项，suc回调打印的的signResult即为签名的加密字符串
function getSig4(_x) {
  return _getSig.apply(this, arguments);
} // 3、获取签名版本号
function _getSig() {
  _getSig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(config) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              Jose.call('$encode', [config, {
                suc: function suc(signResult, signInput) {
                  resolve({
                    signResult: signResult,
                    signInput: signInput
                  });
                },
                err: function err(error) {
                  reject(error);
                }
              }]);
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSig.apply(this, arguments);
}
function getSig4Ver() {
  return Jose.call('$getCatVersion') || '';
}
// 4、建议在网络库的拦截器里，将sig4参数拼接在url上
function generateSig4(_x2, _x3) {
  return _generateSig.apply(this, arguments);
} // 添加请求拦截器
function _generateSig() {
  _generateSig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(axiosConfig, data) {
    var _axiosConfig$headers, _axiosConfig$headers2;
    var url, sig4Version, formdataParams, requestBodyParams, formParams, isPost, contentType, config, _yield$getSig, signResult, divider, sig4Url;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = axiosConfig.url || '';
            if (url) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            sig4Version = getSig4Ver();
            formdataParams = null;
            requestBodyParams = null;
            formParams = null;
            isPost = ['post', 'put', 'patch'].includes(axiosConfig.method || 'get'); // 获取不到的话，走兜底
            contentType = ((_axiosConfig$headers = axiosConfig.headers) === null || _axiosConfig$headers === void 0 ? void 0 : _axiosConfig$headers['Content-Type']) || ((_axiosConfig$headers2 = axiosConfig.headers) === null || _axiosConfig$headers2 === void 0 ? void 0 : _axiosConfig$headers2['content-type']) || 'application/json';
            if (isPost) {
              // content-type = 'application/x-www-form-urlencoded'的情况传入，其他情况可以不传或者传null
              formParams = contentType === 'application/x-www-form-urlencoded' ? data !== null && data !== void 0 ? data : null : null;
              // content-type = 'application/json'的情况传入（如果body是空，传{}），其他情况可以不传或者传null
              requestBodyParams = contentType === 'application/json' ? data !== null && data !== void 0 ? data : null : null;
            }
            // 需要把版本号也传入，参与签名生成；
            config = {
              url: url,
              query: _objectSpread({
                caver: sig4Version
              }, axiosConfig.params || {}),
              form: formParams,
              requestBody: requestBodyParams,
              projectInfo: {
                appKey: '7RVeauGG4t',
                did: '',
                uid: '',
                oversea: true,
                radarId: 'a5e81cbd04',
                sampling: 1,
                debug: false // 是否开启console.log打印，生产环境应禁用
              }
            };
            _context3.next = 13;
            return getSig4(config);
          case 13:
            _yield$getSig = _context3.sent;
            signResult = _yield$getSig.signResult;
            divider = url.includes('?') ? '&' : '?';
            sig4Url = "".concat(url).concat(divider, "__NS_hxfalcon=").concat(signResult, "&caver=").concat(sig4Version);
            return _context3.abrupt("return", sig4Url);
          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _generateSig.apply(this, arguments);
}
service.interceptors.request.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
    var sig4Url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 判断当前请求是否设置了不显示Loading
            if (config !== null && config !== void 0 && config.showLoading && !(config !== null && config !== void 0 && config.silent)) {
              showLoading();
            }
            _context.prev = 1;
            _context.next = 4;
            return generateSig4(config, config.data);
          case 4:
            sig4Url = _context.sent;
            config.url = sig4Url;
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            radarLog({
              name: 'Sig4',
              category: 'Sig4_Url_Err',
              extra_info: JSON.stringify({
                err: _context.t0
              })
            });
          case 11:
            return _context.abrupt("return", config);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function (_x4) {
    return _ref.apply(this, arguments);
  };
}());
service.interceptors.response.use(function (response) {
  var data = response.data,
    config = response.config;
  var showLoading = config.showLoading,
    silent = config.silent,
    erroToast = config.erroToast;
  if (showLoading && !silent) {
    hideLoading();
  }
  // 埋点上报
  logger.sendClick({
    radarName: '通用-接口返回值',
    params: _objectSpread(_objectSpread({}, data || {}), {}, {
      apiUrl: config.url,
      network: navigator.onLine
    })
  });
  if ((data === null || data === void 0 ? void 0 : data.result) !== 1 && !silent && erroToast) {
    var _response$data, _response$data2, _response$data3;
    var $k18n = useK18n();
    var msg = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.error_msg) || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.msg) || (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.ztMsg) || $k18n('未知错误');
    msg && Toast.info(msg);
  }
  return Promise.resolve(data);
}, function (error) {
  var response = error.response;
  // 埋点上报
  logger.sendClick({
    radarName: '通用-接口catch返回值',
    params: {
      error: error
    }
  });
  if (response) {
    var _ref2 = (response === null || response === void 0 ? void 0 : response.config) || {},
      _ref2$showLoading = _ref2.showLoading,
      _showLoading = _ref2$showLoading === void 0 ? false : _ref2$showLoading,
      _ref2$silent = _ref2.silent,
      silent = _ref2$silent === void 0 ? false : _ref2$silent;
    if (_showLoading && !silent) {
      hideLoading();
    }
    if (!silent) {
      Toast.info(error);
      hideLoading();
    }
  } else {
    hideLoading();
    Toast.info(error);
  }
});
/**
 * res.result !== 1 reject
 */
export function resultCodeCheck(_x5) {
  return _resultCodeCheck.apply(this, arguments);
}
function _resultCodeCheck() {
  _resultCodeCheck = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(res.result === 1)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return", res);
          case 2:
            return _context4.abrupt("return", Promise.reject(res));
          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _resultCodeCheck.apply(this, arguments);
}
export default service;
// 请求重试
export var requestRetry = function requestRetry(retryParams) {
  var reqUrl = retryParams.reqUrl,
    reqHead = retryParams.reqHead,
    params = retryParams.params,
    _retryParams$configPa = retryParams.configParams,
    configParams = _retryParams$configPa === void 0 ? {} : _retryParams$configPa,
    _retryParams$times = retryParams.times,
    times = _retryParams$times === void 0 ? 3 : _retryParams$times;
  // 根据请求方法构造正确的请求
  var makeRequest = function makeRequest() {
    var url = reqUrl;
    if (reqHead === 'get') {
      return service.get(url, _objectSpread(_objectSpread({}, params), configParams));
    }
    return service[reqHead](url, params, configParams);
  };
  return new Promise(function (resolve, reject) {
    makeRequest().then(function (res) {
      // 检查响应是否为 null 或 undefined
      if (typeof res === 'undefined' || res === null) {
        if (times > 1) {
          setTimeout(function () {
            requestRetry({
              reqUrl: reqUrl,
              reqHead: reqHead,
              params: params,
              configParams: configParams,
              times: times - 1
            }).then(resolve).catch(reject);
          }, 1000);
        } else {
          // 重试次数用尽，返回 null
          logger.sendClick({
            radarName: '重试-响应为空',
            params: {
              reqUrl: reqUrl
            }
          });
          resolve(null);
        }
      } else {
        resolve(res);
      }
    }).catch(function (err) {
      if (times > 1) {
        setTimeout(function () {
          requestRetry({
            reqUrl: reqUrl,
            reqHead: reqHead,
            params: params,
            configParams: configParams,
            times: times - 1
          }).then(resolve).catch(reject);
        }, 1000);
      } else {
        // 重试次数用尽，返回 null
        logger.sendClick({
          radarName: '重试错误',
          params: {
            reqUrl: reqUrl,
            err: err
          }
        });
        resolve(null);
      }
    });
  });
};